export default __webpack_public_path__ + "static/media/HDTX_Announcement of GMS 2025.2047b8b2.pdf";